import $ from 'jquery';
import 'owl.carousel';
// import AOS from 'aos';

class CCarousel {
  constructor() {
    this.carousel = $('.js-c-carousel');
    this.speed = 1000;
    this.timeout = 5000;

    this.breakpoint = window.matchMedia('(min-width: 1023.99px)');

    $(document).ready(() => {
      this.prepareCarousels();
      this.carousels();
    });
  }

  static isInView(carousel) {
    const elementTop = carousel.offset().top;
    const elementBtm = elementTop + carousel.outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBtm = viewportTop + $(window).height();

    return elementBtm > viewportTop && elementTop < viewportBtm;
  }

  static navVisibility(carousel) {
    const nav = carousel.find('.owl-nav');
    if (nav.length) {
      if (nav.hasClass('disabled')) {
        nav.removeClass('disabled');
      }
      carousel.addClass('has-nav-enabled');
    } else {
      carousel.removeClass('has-nav-enabled');
    }
  }

  static isNavEnabled(carousel) {
    const nav = carousel.find('.owl-nav');

    return nav.length && !nav.hasClass('disabled');
  }

  static partnersBoxesHeight(carousel) {
    const boxes = carousel.find('.js-partner-inner');
    const heights = boxes
      .map((index, elem) => {
        const box = $(elem);

        return box.length ? box.outerHeight() : 0;
      })
      .get();

    const height = Math.max(...heights);
    boxes.css({ 'min-height': height });
  }

  prepareCarousels() {
    if (this.carousel.length) {
      $.each(this.carousel, (i, el) => {
        const carousel = $(el);
        const isContactServicesCarousel = carousel.hasClass(
          'js-contact-services-carousel',
        );

        if (isContactServicesCarousel && this.breakpoint.matches) {
          carousel.removeClass('js-c-carousel owl-carousel');
        }
      });

      this.carousel = $('.js-c-carousel');
    }
  }

  carousels() {
    if (this.carousel.length) {
      $.each(this.carousel, (i, el) => {
        const carousel = $(el);
        let inView = false;
        let itemsCount = carousel.find('.js-c-carousel-item').length;

        if (carousel.hasClass('js-partners-carousel')) {
          itemsCount = Math.ceil(itemsCount / 2);
        }

        // const isLatestNewsCarousel = carousel.hasClass('js-latest-news-carousel');
        // const isBoxesCarousel = carousel.hasClass('js-boxes-carousel');
        const isPartnersCarousel = carousel.hasClass('js-partners-carousel');
        const isGrowthPointsCarousel = carousel.hasClass(
          'js-growthpoints-carousel',
        );
        const isLogosCarousel = carousel.hasClass('js-logos-carousel');
        const isContactServicesCarousel = carousel.hasClass(
          'js-contact-services-carousel',
        );

        // if (carousel.find('.aos-animate').length) {
        //   carousel.find('.aos-animate').removeClass('aos-animate');
        //   AOS.refresh();
        // }

        carousel.on('initialized.owl.carousel', () => {
          setTimeout(() => {
            if (isGrowthPointsCarousel) {
              CCarousel.navVisibility(carousel);

              $(window)
                .on('scroll', () => {
                  if (!inView && CCarousel.isInView(carousel)) {
                    // carousel.data('owl.carousel').options.autoplay = true;
                    carousel.trigger('refresh.owl.carousel');
                    CCarousel.navVisibility(carousel);
                    inView = true;
                  }
                })
                .trigger('scroll');
            } else {
              if (CCarousel.isNavEnabled(carousel)) {
                carousel.addClass('has-nav-enabled');
                carousel.data('owl.carousel').options.loop = true;
              } else {
                carousel.removeClass('has-nav-enabled');
                carousel.data('owl.carousel').options.loop = false;
              }

              carousel.trigger('refresh.owl.carousel');
            }

            if (isPartnersCarousel) {
              CCarousel.partnersBoxesHeight(carousel);
            }
          });
        });

        let args = {
          dots: true,
          nav: true,
          mouseDrag: true,
          touchDrag: true,
          loop: isGrowthPointsCarousel,
          autoplay: false,
          navSpeed: this.speed,
          dotsSpeed: this.speed,
          dragEndSpeed: this.speed,
          margin: 30,
          responsive: {
            0: {
              items: 1,
            },
            768: {
              items: 2,
            },
            1024: {
              items: 3,
            },
          },
        };

        if (itemsCount > 3) {
          args.responsive[2048] = { items: 4 };

          if (itemsCount > 4) {
            args.responsive[2560] = { items: 5 };
          }

          if (itemsCount > 5) {
            args.responsive[3000] = { items: 6 };
          }
        }

        if (isLogosCarousel) {
          args = {
            ...args,
            responsive: {
              0: {
                items: 5,
                margin: 10,
              },
              480: {
                items: 5,
                margin: 30,
              },
            },
            autoWidth: true,
            loop: false,
            autoplay: true,
            autoplaySpeed: 1000,
            autoplayTimeout: 3000,
            autoplayHoverPause: false,
          };
        }

        if (isContactServicesCarousel) {
          args = {
            ...args,
            responsive: {
              0: {
                items: 3,
              },
            },
            autoWidth: true,
            loop: false,
          };
        }

        carousel.owlCarousel(args);

        carousel.on('resized.owl.carousel', () => {
          if (!isGrowthPointsCarousel) {
            if (CCarousel.isNavEnabled(carousel)) {
              carousel.addClass('has-nav-enabled');
              carousel.data('owl.carousel').options.loop = true;
            } else {
              carousel.removeClass('has-nav-enabled');
              carousel.data('owl.carousel').options.loop = false;
            }

            carousel.trigger('refresh.owl.carousel');
          }
        });

        carousel.on('changed.owl.carousel', () => {
          if (isGrowthPointsCarousel) {
            CCarousel.navVisibility(carousel);
          }
        });
      });
    }
  }
}

export default new CCarousel();



// WEBPACK FOOTER //
// ./src/scripts/modules/c-carousel.js